import { DropDownOptions } from "./DropDownOption.model";

export interface SourcingOutcomeInformation {
  RFQSummaryNumber: string | null;
  RFQNumber: string;
  MPDocumentNumber: string;
  CreatedBy: string;
  CreatedOn: Date;
  ROName: string;
  AssignedPE: string;
  SecurityClassIdExt: string;
  DocumentStatusId?: number;
  DocumentStatusName?: string;
  VendorsList: VendorsList[];
  IsRecalled?: boolean;
  arePOCreated?: boolean;
}

export interface VendorsList {
  Id: string | null;
  VendorNumber: string;
  Name: string;
  Status: boolean;
  QuoteExpiring: Date | null;
  ReasonForNoQuotationId: string | null;
  QuotationAttachment: QuotationAttachment[];
  HavingExpiredQuote: boolean | null;
}
export interface QuotationAttachment {
  Id: string | null;
  FileName: string;
  FilePath: string;
  CreatedBy: string;
  AttachmentTypeId: number | null;
  IsStrikethrough: boolean;
  IsDeleted: boolean;
  Data: string;
}

export interface SourcedItem {
  ItemDescription: string;
  PurchaseItemNumber: number;
  RFQItemNumber: number;
  MaterialSubGroupId: string;
  PurchaseItemId: number;
  Quantity: number;
  BrandOEMName: string;
  OtherBrandOEMName: string;
  PartModelNumber: string | null;
  UnitOfMeasurement: string;
  PlannedDeliveryDate: string;
  Vendor: string;
  PONumber: string;
  PODocStatus:string;
  AwardedQuantity: string;
  RFQQuantity: number;
  ReasonForAbort: DropDownOptions | null;
  Id: number;
  AbortReasonId:number
}


export enum RFQSummaryRole {
  RO = 'Requesting officer',
  Assigned_PE = 'Assigned PE',
  Both_PE_RO = 'Both PE and RO',
  Other_PE = 'Not assigned PE',
  NONE = 'None'
}